import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { AnchorText } from 'components/Text';

type Props = {
  text: string;
  characterLimit?: number;
};

const ExpandableText: React.FC<Props> = ({ text, characterLimit = 1000 }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const isHigherThanCharacterLimit = text.length > characterLimit;

  return (
    <Typography variant="body1">
      {expanded || !isHigherThanCharacterLimit
        ? text
        : `${text.slice(0, characterLimit)}...`}

      {isHigherThanCharacterLimit && (
        <AnchorText color="primary" onClick={handleToggle} sx={{ ml: 1 }}>
          {expanded ? 'See less' : 'See more'}
        </AnchorText>
      )}
    </Typography>
  );
};

export { ExpandableText };
